import { Cache } from "~/types/cache";
import { Locale, standardLocale, UrlLangguageLocale } from "~/types/locale";

// 简体以外都是默认英文.
const ZH_CN = "zh-CN"; // Chinese (Simplified)

const getRouteLanguage = () => {
  const route = useRoute();
  return String(route.query.language);
};

const isStandardEffectiveLanguage = (language: string) => {
  return language === standardLocale.ZH_CN || language === standardLocale.EN;
};

const isEffectiveLanguage = (language: string) => {
  return language === Locale.ZH_CN || language === Locale.EN;
};
export function useLocale() {
  const routeLanguage = getRouteLanguage() as keyof typeof UrlLangguageLocale;
  if (!!routeLanguage && isStandardEffectiveLanguage(routeLanguage)) {
    // @ts-ignore
    changeLocale(UrlLangguageLocale[routeLanguage]);
    return;
  }

  // 已经开启了i18n的 Cookie 持久化语言，可以考虑去掉cacheLocale
  const currentLocale = useCookie(Cache.LOCALE);
  const cacheLocale = currentLocale.value as Locale;
  console.log("cacheLocale:", cacheLocale);

  if (!!cacheLocale && isEffectiveLanguage(cacheLocale)) {
    changeLocale(cacheLocale);
    return;
  }

  if (!navigator) return;
  const browserLanguage = navigator.language || navigator.languages[0];
  const languges =
    !!browserLanguage && browserLanguage === ZH_CN ? Locale.ZH_CN : Locale.EN;
  changeLocale(languges);
}

const changeLocale = (locale: Locale) => {
  const { $i18n } = useNuxtApp();
  if (!$i18n) return;
  const { setLocale } = $i18n;
  setLocale(locale);
  const currentLocale = useCookie(Cache.LOCALE);
  currentLocale.value = locale;
};

// 不刷新的页面路径:
// 文章/协议
// 登录/注册/忘记密码
const noRefreshNames = [
  "article-articleId",
  "terms-pathName",
  "account-login",
  "account-register",
  "account-password",
];

export function useSetLocale(locale: Locale) {
  console.log("locale:", locale);

  const currentLocale = useCookie(Cache.LOCALE);
  currentLocale.value = locale;

  const route = useRoute();
  if (noRefreshNames.includes(String(route.name))) {
    changeLocale(locale);
  } else {
    location.reload();
  }
}
